import { makeCell, makeRowSet } from './gridUtill';
let fields = [];
let columns = [];
makeCell(
  8,
  [
    {
      field: 'solvent',
      alias: 'solvent',
    },
    {
      field: 'solventVol',
      alias: 'wt%',
      excelKey: 'vol%_',
    },
  ],
  fields,
  columns,
);
makeCell(
  3,
  [
    {
      field: 'salt',
      alias: 'salt',
    },
    {
      field: 'saltVol',
      alias: 'wt%',
      excelKey: 'wt%_',
    },
  ],
  fields,
  columns,
);
makeCell(
  10,
  [
    {
      field: 'add',
      alias: 'add',
    },
    {
      alias: 'wt%',
      field: 'addVol',
      excelKey: 'wt%_',
    },
  ],
  fields,
  columns,
);
makeCell(
  1,
  [
    {
      field: 'sum',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
);
const rowSet = makeRowSet(fields);
export { fields, columns, rowSet };
